import { useCallback, useMemo } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { updateLoadingState } from '@sales-center/common'
import { useBulkActionContext } from '../../../BulkActionContext'
import { toast } from '@sales-center/components'
import { BulkCloseWinOpportunityInput } from '../../../typings/BulkCloseWin/BulkCloseWinOpportunityInput'

type Params = {
  submitHandler: (model: BulkCloseWinOpportunityInput) => Promise<void>
}

export const useFormActions = (params: Params) => {
  const { submitHandler } = params

  const appDispatch = useAppDispatch()

  const { selectedRows, dispatch } = useBulkActionContext()

  const ids = useMemo(() => selectedRows.map((x) => Number(x)), [selectedRows])

  const handleSubmit = useCallback(
    async (model: BulkCloseWinOpportunityInput) => {
      try {
        appDispatch(updateLoadingState('visible'))

        await submitHandler({
          Ids: ids,
          appData: model.appData,
          salesNote: model.salesNote,
        })

        dispatch({ type: 'setActive' })
      } finally {
        appDispatch(updateLoadingState('hidden'))
        toast.success('Bulk update successfully applied')
      }
    },
    [appDispatch, dispatch, submitHandler, ids],
  )

  return {
    handleSubmit,
    ids,
  }
}
